import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export const INBOX_CHANGED = "request-inbox-changed";

// Tell the sidebar badge a request was just decided.
export const inboxChanged = () => window.dispatchEvent(new Event(INBOX_CHANGED));

// Waiting buyer requests for the sidebar badge: on page change, every minute, and right after a decision.
export function useInboxCount(enabled) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const load = () => api.get("/admin/request-inbox/count")
      .then((r) => { if (live) setCount(r.data.waiting || 0); })
      .catch(() => {});
    load();
    const timer = setInterval(load, 60000);
    window.addEventListener(INBOX_CHANGED, load);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener(INBOX_CHANGED, load);
    };
  }, [enabled, pathname]);
  return count;
}
